import React, { useState, useRef, useEffect } from 'react'
import 'components/Pricing/styles/index.scss'
import OnPremiseOverlay from 'components/Pricing/Overlays/OnPremise'
import EnterpriseOverlay from 'components/Pricing/Overlays/Enterprise'
import WhyCloud from 'components/Pricing/Overlays/WhyCloud'
import Enterprise from 'components/Pricing/Modals/Enterprise'
import Link from 'components/Link'
import { Info } from 'components/Icons/Icons'
import Calculator from 'components/Pricing/Calculator'
import { CloudIcon, OnPremiseIcon } from 'components/Pricing/Calculator'
import useiCloudReady from '../../../hooks/useiCloudReady'
import { useActions, useValues } from 'kea'
import { TrackedCTA } from 'components/CallToAction'
import { pricingSliderLogic } from 'components/Pricing/PricingSlider/pricingSliderLogic'
import { prettyInt, sliderCurve } from 'components/Pricing/PricingSlider/LogSlider'
import { pricing, pricingLabels } from 'components/Pricing/constants'
import { motion } from 'framer-motion'
const Check = () => {
    return (
        <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.9947 5.52548L6.4635 8.99428L14.7025 0.75528C15.2095 0.24824 16.0369 0.24824 16.5439 0.75528L17.3259 1.53732C17.833 2.04436 17.833 2.8717 17.3259 3.37872L7.46034 13.2443C6.95566 13.749 6.13534 13.7521 5.62674 13.2521L0.389145 8.10213C0.126645 7.84509 -0.00381509 7.52713 8.49096e-05 7.15995C0.00399111 6.79277 0.141491 6.47791 0.408685 6.22635L1.18056 5.49979C1.69306 5.01775 2.49696 5.02947 2.99462 5.52714L2.9947 5.52548Z"
                fill="#BFBFBC"
            />
        </svg>
    )
}
const Benefit = ({ children }) => {
    return (
        <li className="flex items-start gap-x-1.5 text-[15px] font-medium leading-tight">
            <span className="mt-[2px] flex w-[24px] flex-shrink-0 items-center justify-center">
                <Check />
            </span>
            <span>{children}</span>
        </li>
    )
}
export const ShowPlan = () => {
    const [currentModal, setCurrentModal] = useState<string | boolean>(false)
    const [enterpriseModalOpen, setEnterpriseModalOpen] = useState(false)
    const [whyCloudOpen, setWhyCloudOpen] = useState(false)
    const [onPremise, setOnPremise] = useState(false)
    const [enterprise, setEnterprise] = useState(false)
    const iCloudReady = useiCloudReady()
    const [showPlanBuilder, setShowPlanBuilder] = useState(false)
    const builderRef = useRef<HTMLDivElement>()
    const {
        propertymanagementcloudCost,
        propertymanagementcloudStandardCost,
        propertymanagementOnPremiseStandardCost,
        propertymanagementcloudEnterpriseCost,
        propertymanagementOnPremiseEnterpriseCost,
        sliderValue,
    } = useValues(pricingSliderLogic)
    const [professionalMode, setProfessionalMode] = useState(false)
    const { setPricingOption, setCrmPricingOption } = useActions(pricingSliderLogic)
    const handleProfessionalModeChange = (checked: boolean) => {
        setPricingOption(checked ? 'propertymanagementcloud-professional' : 'propertymanagementcloud-standard')
        setCrmPricingOption(checked ? 'real-estate-crm-cloud-professional' : 'real-estate-crm-cloud-standard')
        setProfessionalMode(checked)
    }

    const handleInfo = (currentModal: string) => {
        setCurrentModal(currentModal)
    }

    useEffect(() => {
        if (showPlanBuilder) builderRef.current?.scrollIntoView({ behavior: 'smooth' })
    }, [showPlanBuilder])
    return (
        <div>
            <OnPremiseOverlay open={currentModal === 'onpremise'} setOpen={setCurrentModal} />
            <EnterpriseOverlay open={currentModal === 'enterprise'} setOpen={setCurrentModal} />
            <WhyCloud open={whyCloudOpen} setOpen={setWhyCloudOpen} />
            <Enterprise open={enterpriseModalOpen} setOpen={setEnterpriseModalOpen} />
            <section className="mx-auto flex max-w-6xl flex-col items-start gap-12 px-4 md:flex-row">
                <div className="col-span-2 grid grow gap-x-8 md:grid-cols-2 md:grid-rows-[1fr_max-content]">
                    <div className="relative order-1 rounded-tl rounded-tr border-l-3 border-t-3 border-r-3 border-solid border-red bg-white px-8 pt-8 pb-2 shadow-xl ">
                        <div className="mb-4">
                            <CloudIcon className="mb-3 opacity-30" />
                            <h2 className="mb-1 flex items-center text-xl">
                                {professionalMode ? (
                                    ' iCloudReady Property Management Professional Cloud'
                                ) : (
                                    <>
                                        iCloudReady Property Management Standard Cloud{' '}
                                        <span className="absolute -top-[3px] right-3 ml-2 inline-flex space-x-1 rounded-[3px] bg-red px-3 py-2 text-sm font-semibold">
                                            <span className="font-bold text-white">Recommended</span>
                                            <button onClick={() => setWhyCloudOpen(true)} className="text-white">
                                                <Info />
                                            </button>
                                        </span>
                                    </>
                                )}
                            </h2>
                            <p className="mb-2 text-sm leading-tight ">
                                SaaS solution managed by the iCloudReady core team
                            </p>
                        </div>

                        <ul className="m-0 grid list-none gap-y-2 p-0">
                            <Benefit>Full product suite</Benefit>
                            <Benefit>Hosted & managed by iCloudReady</Benefit>
                            <Benefit>Always get the latest features</Benefit>
                        </ul>
                    </div>

                    <div className="order-3 rounded-md bg-white px-8 pt-8 pb-2 shadow-xl md:order-2">
                        <div className="mb-4">
                            <OnPremiseIcon className="mb-3 opacity-30" />
                            <h2 className="mb-1 flex items-center text-xl">
                                {professionalMode
                                    ? 'iCloudReady On-premise Property Management Enterprise'
                                    : 'iCloudReady On-premise Property Management Standard'}
                            </h2>
                            <p className="mb-2 text-sm leading-tight ">
                                Customer data never leaves your infrastructure
                            </p>
                        </div>

                        <ul className="m-0 grid list-none gap-y-2 p-0">
                            <Benefit>Full feature set of iCloudReady Cloud but on your infrastructure</Benefit>
                            <Benefit>Full access to your production instance</Benefit>
                            <Benefit>Paid deployment support available in the iCloudReady partner directory</Benefit>
                        </ul>
                    </div>

                    <div className="relative order-2 mb-8 rounded-bl rounded-br border-l-3 border-b-3 border-r-3 border-solid border-red bg-white px-8 pb-8 shadow-xl md:order-3 md:mb-0">
                        <div className="mt-4 flex justify-between border-t border-dashed border-gray-accent pt-2">
                            <div className="flex flex-col">
                                <strong className="text-[16px]">Monthly estimate</strong>
                                <span className="text-sm text-black/60">
                                    for {sliderValue ? prettyInt(sliderCurve(sliderValue)) : '1,000,000'} events/mo
                                </span>
                            </div>
                            <div>
                                <strong className="text-[18px] text-black">
                                    $
                                    {prettyInt(
                                        professionalMode
                                            ? propertymanagementcloudEnterpriseCost
                                            : propertymanagementcloudStandardCost
                                    )}
                                </strong>
                                <span className="text-sm text-black/60">/mo</span>
                            </div>
                        </div>

                        <div className="mt-4">
                            <TrackedCTA
                                event={{
                                    name: `clicked Get started - free`,
                                    type: professionalMode
                                        ? 'propertymanagementcloud-professional'
                                        : 'propertymanagementcloud-standard',
                                }}
                                type="primary"
                                width="full"
                                className="shadow-md"
                                to={
                                    professionalMode
                                        ? 'https://icloud-ready.com/signup/cloud/professional'
                                        : `https://${
                                              iCloudReady?.isFeatureEnabled &&
                                              iCloudReady?.isFeatureEnabled('direct-to-saudi-cloud')
                                                  ? 'eu'
                                                  : 'app'
                                          }.icloud-ready.com/signup`
                                }
                            >
                                {professionalMode ? 'book a meeting' : 'Get started - free'}
                            </TrackedCTA>
                        </div>
                    </div>

                    <div className="order-4 rounded-bl rounded-br bg-white px-8 pb-8 shadow-xl">
                        <div className="mt-4 flex justify-between border-t border-dashed border-gray-accent pt-2">
                            <div className="flex flex-col">
                                <strong className="text-[16px]">Monthly estimate</strong>
                                <span className="text-sm text-black/60">
                                    for {sliderValue ? prettyInt(sliderCurve(sliderValue)) : '1,000,000'} events/mo
                                </span>
                            </div>
                            <div>
                                <strong className="text-[18px] text-black">
                                    $
                                    {prettyInt(
                                        professionalMode
                                            ? propertymanagementOnPremiseEnterpriseCost
                                            : propertymanagementOnPremiseStandardCost
                                    )}
                                </strong>
                                <span className="text-sm text-black/60">/mo</span>
                            </div>
                        </div>

                        <div className="mt-4">
                            <TrackedCTA
                                event={{
                                    name: `clicked Get started - free`,
                                    type: professionalMode
                                        ? 'property-management-on-premise-professional'
                                        : 'property-management-on-premise-standard',
                                }}
                                type="primary"
                                width="full"
                                className="shadow-md"
                                to={
                                    professionalMode
                                        ? 'https://license.icloud-ready.com/?price_id=price_1L1AeWEuIatRXSdzj0Y5ioOU'
                                        : 'https://license.icloud-ready.com/'
                                }
                            >
                                Get started - free
                            </TrackedCTA>
                        </div>
                    </div>

                    <div className="order-5 mt-8 md:col-span-2">
                        <div className="mx-auto mb-6 flex justify-center space-x-8 border-b border-dashed border-gray-accent-light pb-4">
                            <Link
                                to="/book-a-meeting"
                                className="group flex items-center space-x-2 rounded-sm py-2 px-3 text-[15px] font-semibold text-blue hover:bg-blue/10 hover:text-blue"
                            >
                                <svg
                                    width="24"
                                    height="17"
                                    viewBox="0 0 24 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="text-black/30 group-hover:text-blue"
                                >
                                    <path
                                        d="M3.105 0.499996C2.21906 0.499996 1.5 1.22 1.5 2.105V13.9999H0V15.4558C0 16.308 0.691872 16.9999 1.54406 16.9999H22.3182C23.2473 16.9999 24.0001 16.2471 24.0001 15.318V13.9999H22.5001V2.05244C22.5001 1.19744 21.8026 0.499924 20.9476 0.499924L3.105 0.499996ZM3.105 2L20.9999 2.0525V13.9999H13.4737C13.4662 14.8249 12.7912 15.4999 11.9653 15.4999C11.1375 15.4999 10.4625 14.8268 10.4568 13.9999H3.00002V2.10506C3.00002 2.04693 3.0469 2.00006 3.10502 2.00006L3.105 2ZM12.0347 3.5C10.3744 3.5 9.0234 4.86406 9.0234 6.54416C9.0234 7.94854 9.97214 9.1232 11.25 9.47384C9.14246 9.68384 7.22155 10.7816 5.95867 12.4916H10.0161C10.2833 12.4869 10.557 12.486 10.8364 12.4916H13.3209C13.5037 12.4888 13.6847 12.4897 13.8628 12.4916H18.0169C16.7691 10.7994 14.8811 9.70544 12.7989 9.47672C14.0861 9.13172 15.0432 7.9542 15.0432 6.54416C15.0442 4.86416 13.6961 3.5 12.0358 3.5H12.0347Z"
                                        fill="currentColor"
                                    />
                                </svg>

                                <span>Schedule a demo</span>
                            </Link>
                            <Link
                                to="/book-a-meeting#contact"
                                className="group flex items-center space-x-2 rounded-sm py-2 px-3 text-[15px] font-semibold text-blue hover:bg-blue/10 hover:text-blue"
                            >
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="text-black/30 group-hover:text-blue"
                                >
                                    <path
                                        d="M18.7569 1.24141C18.4467 0.932806 17.9842 0.826566 17.5717 0.975786L1.6631 6.65779C1.23498 6.81013 0.938096 7.20389 0.910756 7.65779C0.883412 8.11247 1.12952 8.53825 1.53732 8.74295L6.74832 11.3475L13.4085 6.59055L8.65072 13.2523L11.2553 18.4633C11.4491 18.8493 11.8436 19.0907 12.2725 19.0907C12.2959 19.0907 12.3186 19.0899 12.3412 19.0883C12.7959 19.0618 13.1905 18.7657 13.3436 18.3368L19.0256 2.42658C19.1717 2.01408 19.0678 1.55158 18.7568 1.24142L18.7569 1.24141Z"
                                        fill="currentColor"
                                    />
                                </svg>

                                <span>book a meeting</span>
                            </Link>
                        </div>
                        <div>
                            <h4 className="mb-0 text-[15px] font-normal opacity-75">
                                <span className="font-bold">
                                    Looking for{' '}
                                    <Link
                                        className="border-b border-dashed border-gray-accent-light text-black"
                                        onClick={() =>
                                            iCloudReady &&
                                            iCloudReady.capture('clicked Browse on GitHub', { type: 'on-permise' })
                                        }
                                        to="https://github.com/icloud-ready/icloudready"
                                    >
                                        iCloudReady Open Source
                                    </Link>
                                    ?
                                </span>{' '}
                                (No credit card required)
                            </h4>
                            <p className="text-sm opacity-60">
                                Available with property management, feature flags, and real estate crms – limited to 1
                                project and no user permissions
                            </p>
                        </div>
                    </div>
                </div>
                <div className="box-border flex flex-shrink md:basis-96">
                    <div className="mx-auto md:max-w-[290px]">
                        <Calculator
                            professionalMode={professionalMode}
                            handleProfessionalModeChange={handleProfessionalModeChange}
                            enterprise={enterprise}
                            onPremise={onPremise}
                            setCurrentModal={setCurrentModal}
                        />
                    </div>
                </div>
            </section>
        </div>
    )
}
